import { cn } from '../../utils/cn'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...props}
    />
  )
}

/**
 * Placeholder for a single value that hasn't loaded yet, for use inline in a row of text.
 * Sized in `em` so it matches whatever text size it sits in and can't change the row's height,
 * and inline so it holds the value's place rather than collapsing the line.
 *
 * Carries the word "Loading" for assistive tech: a bar that is only visual leaves the row reading
 * as a label with no value, which is the same ambiguity a `0` creates.
 */
function SkeletonText({ className, ...props }: Omit<React.ComponentProps<'span'>, 'children'>) {
  return (
    <span
      data-slot="skeleton-text"
      className={cn(
        'bg-accent inline-block h-[1em] w-16 animate-pulse rounded-md align-middle',
        className
      )}
      {...props}
    >
      <span className="sr-only">Loading</span>
    </span>
  )
}

export { Skeleton, SkeletonText }
